const rankingData = [
  { rank: 1, title: '某顶流男星隐婚三年深度起底', heat: '🔥 98.6 万热度', trend: 'up', change: '+12' },
  { rank: 2, title: '两大千万粉网红直播间对质', heat: '🔥 87.3 万热度', trend: 'up', change: '+8' },
  { rank: 3, title: '某综艺节目录制现场冲突', heat: '🔥 74.2 万热度', trend: 'up', change: '+23' },
  { rank: 4, title: '某女星深夜出入神秘豪宅', heat: '🔥 65.8 万热度', trend: 'down', change: '-5' },
  { rank: 5, title: '美妆博主学历造假事件', heat: '🔥 58.1 万热度', trend: 'up', change: '+15' },
  { rank: 6, title: '奢侈品牌代言人突遭解约', heat: '🔥 49.7 万热度', trend: 'down', change: '-2' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">热搜风云榜</h2>
          <p className="mt-2 text-sm text-foreground-600">实时热度排行，看看今天大家都在追哪些瓜</p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankingData.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 px-5 py-4 cursor-pointer hover:bg-background-50 transition-colors duration-150 group ${
                i < rankingData.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <span className={`w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg text-sm font-bold whitespace-nowrap ${
                item.rank === 1 ? 'bg-accent-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-300 text-accent-900' :
                item.rank === 3 ? 'bg-accent-200 text-accent-800' :
                'bg-secondary-100 text-secondary-700'
              }`}>
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-500 transition-colors truncate">{item.title}</p>
                <p className="text-xs text-foreground-500 mt-0.5">{item.heat}</p>
              </div>
              <span className={`flex-shrink-0 text-xs font-semibold whitespace-nowrap flex items-center gap-0.5 ${
                item.trend === 'up' ? 'text-accent-600' : 'text-secondary-500'
              }`}>
                <i className={`text-xs ${item.trend === 'up' ? 'ri-arrow-up-line' : 'ri-arrow-down-line'}`}></i>
                {item.change}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}